var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"padding-top":"2em"}},[_c('ContactForm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }